<template>
  <div>
    <el-card>
      <!-- <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth"> -->
        <el-row :gutter="20">
          <el-col :sm="4" :md="4" :lg="4">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                placeholder="请选择所属科目"
                v-model="courseIds"
                :options="subjectTreeList"
                :props="subjectTreeProps"
              ></el-cascader>
              <!-- @change="subjectChange" -->
          </el-col>
          <el-col :sm="4" :md="4" :lg="4">
              <el-input v-model="searchForm.name" placeholder="请输入学员姓名/手机号" auto-complete="off"></el-input>
          </el-col>

          <!-- <el-col :sm="4" :md="4" :lg="4">
              <el-select
                multiple
                collapse-tags
                clearable
                v-model="searchForm.studentGroupIds"
                placeholder="请选择学员分组"
              >
                <el-option
                  v-for="item in studentGroupLIst"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
          </el-col> -->
          <el-col :sm="8" :md="8" :lg="8">
              <el-date-picker
              style="width:100%"
                v-model="searchForm.createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="注册开始日期"
                end-placeholder="注册结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
          </el-col>
          <el-col :sm="4" :md="4" :lg="4">
              <el-select v-model="searchForm.fromType" placeholder="请选择注册来源">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>
          </el-col>
          <el-col :sm="4" :md="4" :lg="4">
            <div class="button-Array">
              <!-- <a class="mainColor mr" @click="reset" icon="el-icon-refresh">重置</a> -->
              <div class="button-Arrays">
                <el-button type="primary" @click="page.pageNumber=1,pageList()" icon="el-icon-search">查询</el-button>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20" style="margin-top:20px">
          <el-col :sm="24" :md="24" :lg="24">
            <div class="button-Array">
              <a class="mainColor mr" @click="reset" icon="el-icon-refresh">重置</a>
              <div class="button-Arrays">
                <el-button type="primary" @click="page.pageNumber=1,pageList()" icon="el-icon-search">查询</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :span="24"></el-row> -->
      <!-- </el-form> -->
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <!-- <el-button type="danger" @click="batchDeleteStudent" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
        <!-- <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 0px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column show-overflow-tooltip width="160" prop="account" label="班级">
          <template slot-scope="scope">
            <span>{{scope.row.studentGroup?scope.row.studentGroup.name:'无'}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="name" label="姓名"></el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="mobile" label="手机号"></el-table-column>

        <el-table-column show-overflow-tooltip prop label="做题情况" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span>试卷：{{scope.row.examNum}}题</span>
              <span>章节：{{scope.row.chapterNum}}题</span>
              <span>考点：{{scope.row.knowledgeNum}}题</span>
              <span>错题：{{scope.row. wrongNum}}</span>
              <!-- <span @click="goDetial" class="mainColor">查看</span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="createTime" label="开课时间"></el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="lastExerciseTime" label="近期做题日期"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";

export default {
  data() {
    return {
      groupList: [],
      studentGroupLIst: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      options: [],
      courseIds: [],
      loading: true,
      subjectTreeList: [], //科目
      searchForm: {
        studentGroupIds: [],
        courseId: "",
        name: "",
        account: "",
        fromType: "",
        createTime: ""
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: false,
        children: "children"
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    goDetial() {
      // this.$router.push({ path: "/detial" });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    subjectChange(val) {
      this.searchForm.courseId = val[2];
      // this.searchForm.courseIds = [];
      // val.forEach(item => {
      // });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      delete this.searchForm.courseIds;
      this.api.student
        .exercisePageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },

    reset() {
      this.searchForm.studentGroupIds = [];
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },

    getStudentGroupList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                }
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
          if(this.subjectTreeList.length>0){
            this.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.pageList();
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.api.student
        .getStudentGroupList({})
        .then(result => {
          this.groupList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.api.student
        .getStudentFromTypeList({})
        .then(result => {
          this.options = result.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.api.student
        .getStudentGroupList({})
        .then(result => {
          this.studentGroupLIst = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    "searchForm.createTime": function(newVal) {
      this.searchForm.createTimeStart = newVal[0];
      this.searchForm.createTimeEnd = newVal[1];
    },
    courseIds: function(newVal) {
      this.searchForm.courseId = this.courseIds[this.courseIds.length - 1];
    }
  },
  mounted() {
    this.getStudentGroupList();
  }
};
</script>
<style lang="less" scoped>
.el-select {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/condition/index.vue